import {TILES} from "../components/Tile";


export const UPDATE_ACTIVITY = "UPDATE_ACTIVITY";
export const updateActivity = () => {
  const now = new Date();
  return {
    type: UPDATE_ACTIVITY,
    now: now.toISOString()
  }
};


export const SELECT_TILE = "SELECT_TILE";
export const selectTile = tile => {
  let error = null;
  if(!TILES[tile]){
    tile = 'contact';
    error = 'Tile not found';
  }
  else{
    error = null;
  }
  return {type: SELECT_TILE, tile: tile, error: error}
};

export const SELECT_VIEW_ID = "SELECT_VIEW_ID";
export const selectViewId = id => ({
  type: SELECT_VIEW_ID,
  id: id
});

export const COMPLETE_HYDRATION = "COMPLETE_HYDRATION";
export const completeHydration = () => {
  return {
    type: COMPLETE_HYDRATION
  }
};


export const REQUEST_UPDATES = "REQUEST_UPDATES";
export const FETCH_UPDATES_SUCCESS = "FETCH_UPDATES_SUCCESS";
export const FETCH_UPDATES_ERROR = "FETCH_UPDATES_ERROR";
export const fetchUpdates = () => ({
  type: REQUEST_UPDATES,
  meta: {
    offline: {
      effect: {url: '/api/v2/updates', method: 'GET'},
      commit: {
        type: FETCH_UPDATES_SUCCESS,
      },
      rollback: {
        type: FETCH_UPDATES_ERROR,
      }
    }
  }
});


export const REQUEST_LIST = "REQUEST_LIST";
export const FETCH_LIST_SUCCESS = "FETCH_LIST_SUCCESS";
export const FETCH_LIST_ERROR = "FETCH_LIST_ERROR";
export const fetchList = name => ({
  type: REQUEST_LIST,
  meta: {
    offline: {
      effect: {url: '/api/v2/' + name, method: 'GET'},
      commit: {
        type: FETCH_LIST_SUCCESS,
        meta: { name }
      },
      rollback: {
        type: FETCH_LIST_ERROR,
        meta: { name }
      }
    }
  }
});




// WEBPACK FOOTER //
// ./src/actions/actions.js